// src/pages/DeportePage.jsx
import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { firebaseService } from "../services/firebaseService";
import { cld } from "../services/cloudinaryService";
import { DEPORTES } from "../data/deportes";
import AlbumManager from "../components/AlbumManager";
import "../styles/deportePage.css";

const fecha = (iso) =>
    iso ? new Date(iso).toLocaleDateString("es-MX", { month: "short", year: "numeric" }) : "";

export default function DeportePage({ isAdminMode = false }) {
    const { deporteId } = useParams();
    const { currentUser } = useAuth();
    const [albumes, setAlbumes] = useState([]);
    const [loading, setLoading] = useState(true);

    const deporte = DEPORTES[deporteId];
    const isAdmin = isAdminMode && currentUser;

    useEffect(() => {
        if (!deporte || isAdmin) return;
        setLoading(true);
        // El servicio ya los regresa ordenados por "orden"
        firebaseService.getAlbumesByDeporte(deporteId)
            .then(setAlbumes)
            .finally(() => setLoading(false));
    }, [deporteId, deporte, isAdmin]);

    if (!deporte) {
        return (
            <div className="state page-top">
                <h1 className="display">Deporte no encontrado</h1>
                <Link to="/" className="btn">Volver al inicio</Link>
            </div>
        );
    }

    if (isAdmin) {
        return (
            <div className="admin-deporte-page">
                <h1>Administración — {deporte.nombre}</h1>
                <AlbumManager deporte={deporte} deporteId={deporteId} />
                <Link to={`/deporte/${deporteId}`} className="btn-volver">← Ver página pública</Link>
            </div>
        );
    }

    return (
        <div className="deporte-page">
            <section
                className={`deporte-hero ${deporte.imagen ? "" : "category-sin-foto"}`}
                style={deporte.imagen ? { backgroundImage: `url(${deporte.imagen})` } : undefined}
            >
                <div className="deporte-hero-inner">
                    <span className="eyebrow">Portafolio</span>
                    <h1 className="display">{deporte.nombre}</h1>
                    <p>{deporte.lema}</p>
                </div>
            </section>

            <section className="albumes">
                <div className="albumes-head">
                    <h2 className="mono">Álbumes</h2>
                    {!loading && <span className="mono">{String(albumes.length).padStart(2, "0")}</span>}
                </div>

                {loading ? (
                    // Misma forma que la tarjeta real (foto + título + datos) para que nada brinque al cargar
                    <div className="albumes-grid" aria-busy="true" aria-label="Cargando álbumes">
                        {[0, 1, 2].map((i) => (
                            <div key={i} className="album-card">
                                <div className="album-card-img ph" />
                                <div className="album-card-body">
                                    <span className="ph ph-line" style={{ width: "55%" }} />
                                    <span className="ph ph-line" style={{ width: "25%" }} />
                                </div>
                            </div>
                        ))}
                    </div>
                ) : albumes.length === 0 ? (
                    <div className="state">Pronto habrá álbumes aquí.</div>
                ) : (
                    <div className="albumes-grid">
                        {albumes.map((album) => {
                            const portada = album.fotos[0]?.url;
                            return (
                                <Link key={album.id} to={`/album/${album.id}`} className="album-card">
                                    <div className={`album-card-img ${portada ? "ph" : ""}`}>
                                        {portada ? (
                                            <img
                                                src={cld(portada, 800)}
                                                srcSet={`${cld(portada, 500)} 500w, ${cld(portada, 800)} 800w, ${cld(portada, 1100)} 1100w`}
                                                sizes="(max-width: 820px) 100vw, 33vw"
                                                alt=""
                                                loading="lazy"
                                                decoding="async"
                                            />
                                        ) : (
                                            <span className="mono">Sin fotos</span>
                                        )}
                                    </div>
                                    <div className="album-card-body">
                                        <h3>{album.nombre}</h3>
                                        <span className="mono">
                                            {album.fotos.length} fotos{album.fechaCreacion && ` · ${fecha(album.fechaCreacion)}`}
                                        </span>
                                    </div>
                                </Link>
                            );
                        })}
                    </div>
                )}
            </section>
        </div>
    );
}
